import { useState, useEffect } from "react";
import { setAuthToken } from "../api/auth.ts";

interface AuthResult {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

// =================================================================
// ★ テスト用設定: 認証を行うかどうか (true: 認証あり, false: 認証スキップ)
// =================================================================
const ENABLE_AUTH = true;

export function useAuth(honbuId: number, roomId: number): AuthResult {
  const [isAuthenticated, setIsAuthenticated] = useState(!ENABLE_AUTH);
  const [isLoading, setIsLoading] = useState(ENABLE_AUTH);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 認証OFFなら即認証成功扱い
    if (!ENABLE_AUTH) return;

    if (honbuId === 0) {
      setIsAuthenticated(false);
      setIsLoading(false);
      setError("必要なパラメータが不足しています。");
      return;
    }

    const checkAuth = async () => {
      try {
        const res = await fetch(
          `/api/check?honbuid=${honbuId}&roomid=${roomId}`,
        );
        if (res.ok) {
          // 以降の /api/files リクエストで使うアプリトークンを保存
          const data = await res.json();
          setAuthToken(data.token ?? null);
          setIsAuthenticated(true);
          setError(null);
        } else {
          setIsAuthenticated(false);
          setError(
            "認証に失敗しました。セッションが期限切れの可能性があります。",
          );
        }
      } catch {
        setIsAuthenticated(false);
        setError("サーバーに接続できませんでした。");
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [honbuId, roomId]);

  return { isAuthenticated, isLoading, error };
}
